import { BasePalette } from '../general/color-palette';
import { Theme } from '../general/theme';
import { TextDirection } from '../general/text-direction';

const base: BasePalette = {
  100: '#000000', // black
  105: '#111111',
  110: '#1D1D1B',
  150: '#333333',
  180: '#4D4D4D',
  185: '#6C6C6C',
  190: '#B4B4B4',
  200: '#CCCCCC',
  300: '#DC262B',
  800: '#ECECEC',
  900: '#FFFFFF', // white
};

export const abarthTheme: Theme = {
  currentDirection: 'ltr',
  color: {
    base,
    primary: base,
    secondary: base,
    accent: base,
  },
  font: {
    normal: 'Abarth, Arial',
    primary: 'Abarth, Arial',
    secondary: 'Abarth, Arial',
    tertiary: 'Abarth, Arial',
    accent: 'Abarth, Arial',
  },
  fontSize: {
    smaller: 11,
    small: 14,
    normal: 16,
    big: 24,
    bigger: 26,
    large: 36,
    extraLarge: 48,
    huge: 52,
  },
  breakPoint: {
    mobile: 450,
    tablet: 960,
    smallDesktop: 1280,
  },
  get direction() {
    return this.currentDirection;
  },
  set direction(direction: TextDirection) {
    this.currentDirection = direction;
  },
};
